import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconPlay({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M6.866 16.242c-1.306.81-2.366.173-2.366-1.427V3.188c0-1.602 1.056-2.242 2.366-1.43l10.106 6.268c.867.539.874 1.406 0 1.948L6.866 16.242z"/>
        </svg>
    );
}

export default IconPlay;
